import { Link, useLocation } from 'react-router-dom';
import { Activity, Building2, LayoutDashboard, MapPin, Hammer, CircleDollarSign, BrainCircuit, Sparkles, Bot, ListTodo, Wrench, Grid3x3 } from 'lucide-react';
import { Button } from './ui/button';

const AppSidebar = () => {
  const location = useLocation();

  return (
    <div className="h-full fixed left-0 top-0 bottom-0 w-[280px] border-r px-2 pt-[56px] bg-background">
      <Button className="w-full justify-start" variant={location.pathname === '/' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/">
          <LayoutDashboard />
          Dashboard
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname.startsWith('/company') ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/company">
          <Building2 />
          Companies
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname === '/feature-usage' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/feature-usage">
          <Grid3x3 />
          Feature Usage
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname.startsWith('/sector-type') ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/sector-type">
          <Hammer />
          Sector Types
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname === '/msa-premium-defaults' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/msa-premium-defaults">
          <MapPin />
          MSA Premiums
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname === '/global-currencies' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/global-currencies">
          <CircleDollarSign />
          Currencies
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname === '/request-analytics' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/request-analytics">
          <Activity />
          Request Analytics
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname === '/cleanup-cost-data' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/cleanup-cost-data">
          <Sparkles />
          Cleanup Runs History
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname === '/llm-usage' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/llm-usage">
          <BrainCircuit />
          LLM Usage
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname === '/ai-agents' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/ai-agents">
          <Bot />
          AI Agents
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname.startsWith('/tasks') ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/tasks">
          <ListTodo />
          Tasks
        </Link>
      </Button>
      <Button className="w-full justify-start" variant={location.pathname === '/tools' ? 'secondary' : 'ghost'} asChild>
        <Link component={Link} to="/tools">
          <Wrench />
          Tools
        </Link>
      </Button>
    </div>
  );
};

export default AppSidebar;
